import React, { useState } from 'react';
import { useTheme } from '../../../ThemeContext.tsx';
import ProgressBar from '../../ProgressBar.tsx';
import WelcomeCard from './WelcomeCard.tsx';
import { getCategoriesByPillar, DEFAULT_PILLAR_ID } from './data.tsx';
import { WelcomeScreenProps } from './types';

const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ onQuestionSelect }) => {
    const { colors, isMobile } = useTheme();
    const [activePillar, setActivePillar] = useState(DEFAULT_PILLAR_ID);

    // Get categories for the active pillar
    const categories = getCategoriesByPillar(activePillar);

    const handlePillarSelect = (pillarId: string) => {
        setActivePillar(pillarId);
    };

    return (
        <div 
            className={`flex flex-col items-center justify-start text-center pt-2 sm:pt-4 ${isMobile ? 'overflow-y-auto' : ''}`} 
            style={{ height: isMobile ? 'auto' : '70vh', maxHeight: isMobile ? '70vh' : undefined }}
        >
            <div className={`max-w-7xl mx-auto w-full px-3 sm:px-4 lg:px-6 flex flex-col ${isMobile ? '' : 'h-full'}`}>
                {/* Welcome Message */}
                <h1 className={`
                    text-lg sm:text-xl
                    font-bold 
                    ${colors.text.primary} 
                    mb-2 sm:mb-3
                    px-2
                    flex-shrink-0
                `}>
                    Welcome, I am Grippy AI Assistant, how may I help you?
                </h1>

                {/* Progress Bar */}
                <div className="mb-2 sm:mb-3 flex-shrink-0">
                    <ProgressBar 
                        activePillar={activePillar} 
                        onPillarSelect={handlePillarSelect} 
                    />
                </div>

                {/* Cards Grid - fills remaining space, centered for 3 columns */}
                <div className={`pr-1 ${isMobile ? '' : 'flex-1 min-h-0'} flex justify-center`}>
                    <div className={`
                        grid 
                        grid-cols-1 
                        sm:grid-cols-2 
                        lg:grid-cols-3 
                        gap-3 sm:gap-5
                        max-w-5xl
                        ${isMobile ? '' : 'h-full'}
                    `}>
                        {categories.map((category, index) => (
                            <WelcomeCard
                                key={category.id}
                                card={category}
                                onQuestionSelect={onQuestionSelect}
                                defaultExpanded={index === 0}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WelcomeScreen;
